import { Component, Input } from '@angular/core';

// Overview: the client who ordered the inspection (was overview/items/item-four).
@Component({
  selector: 'app-overview-ordered-by',
  templateUrl: './overview-ordered-by.component.html'
})
export class OverviewOrderedByComponent {
  @Input() job: any;
}
